if (!customElements.get('stock-display-cc')) {
    class StockDisplayCC extends HTMLElement {
        productAvailabilityCache = null;
        
        constructor() {
            super();
            this.currentStoreCookie = this.getCookie('currentStore');
            this.stockDisplayQueryId = this.dataset.stockDisplayQueryId;
            this.blockClickCollect = this.dataset.blockClickCollect === 'true';
            this.provinceSelectionElement = this.querySelector('#stock-display__province-selection');
            this.storeSelectionElement = this.querySelector('#stock-display__store-selection');
            this.storeMessageElement = this.querySelector('#stock-display__message');
            this.storeNameElement = this.querySelector('.stock-display__store-name');
            this.storeToolbarElement = this.querySelector('.stock-display__toolbar');
            this.storeResultElement = this.querySelector('.stock-display__row.result');
            this.inStoreRowElement = this.querySelector('.stock-display__row.in-store');
            this.clickCollectRowElement = this.querySelector('.stock-display__row.click-collect');
            this.storeLabelElement = this.querySelector('#stock-display__label-store');
            this.clickCollectLabelElement = this.querySelector('#stock-display__label-click-collect');
            this.deliveryStatusElement = this.querySelector('#stock-display__status-delivery .stock-display__placeholder');
            this.storeStatusElement = this.querySelector('#stock-display__status-store .stock-display__placeholder');
            this.clickCollectElement = this.querySelector('#stock-display__status-click-collect .stock-display__placeholder');
            this.collapsibleTriggerElements = this.querySelectorAll('.stock-display__collapsible-trigger');
            this.collapsibleElement = this.querySelector('#stock-display__collapsible');
            this.currentProductId = this.dataset.productId;
            this.currentVariantId = this.dataset.variantId;
            this.currentLocationId = this.currentStoreCookie?.dataId ?? '';
            this.inventoryByVariantId = {};
            this.storeLabelElementTab = document.querySelector('[data-value-in-store]');
            this.clickCollectLabelElementTab = document.querySelector('[data-value-collect]');
            this.thresholdLowStock = parseInt(this.dataset.lowStoreStockThreshold) || 5;
            this.eleCurrentStore = this.querySelector(".stock-display__current-store");
            this.init();
        }
        
        init() {
            const productId = this.currentProductId;
            const variantId = this.currentVariantId;
            const locationId = this.currentLocationId;
            const startAvailabilityLogic = () => {
                this.loadProductAvailability(productId).then(() => {
                    this.createSelections(variantId);
                    this.setCurrentStore();
                    this.setStockAvailability(variantId, locationId);
                });
            };
            const variantInputs = Array.from(document.querySelectorAll('[data-single-option-selector]'));
            const isAlreadyCleared = !variantInputs.some(i => i.checked);
            const hasSingleOption = variantInputs.length < 2;
            if (isAlreadyCleared || hasSingleOption) {
                startAvailabilityLogic();
            } else {
                document.addEventListener('variant-inputs-cleared', () => {
                    startAvailabilityLogic();
                }, { once: true });
            }
            this.collapsibleEvent();
            this.onVariantChange();
            document.addEventListener('global-store-sync', (event) => {
                if (event.detail.sender === this.tagName.toLowerCase()) return;
                this.syncFromExternal(event.detail.storeData);
            });
        }
        
        async fetchProductAndLocationData(productId) {
            const url = `/apps/datajet/task/${this.stockDisplayQueryId}`;
            const payload = { productId };
            
            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload)
                });
                
                const responseJson = await response.json();
                if (response.ok && responseJson?.data?.product && responseJson?.data?.locations) {
                    console.log("check return data", responseJson.data.product);
                    return responseJson.data;
                } else {
                    console.error("Invalid response structure:", responseJson);
                    return {};
                }
            } catch (error) {
                console.error("Fetch Error:", error);
                return {};
            }
        }
        
        getVariantAvailabilityByLocationId(variantId, locationId) {
            
            const stockAvailability = this.productAvailabilityCache || {};
            // const stockAvailability = await this.loadProductAvailability(this.currentProductId);
            const variantKey = `gid://shopify/ProductVariant/${variantId}`;
            const locationKey = `gid://shopify/Location/${locationId}`;    
            const variantData = stockAvailability[variantKey];
            
            if (!variantData) {
                return {
                    storeStockStatus: 'out-of-stock',
                    warehouseStockStatus: 'out-of-stock',
                    clickCollectStatus: 'unavailable',
                    warehouseQuantity: 0,
                    hasAnyStoreStock: false,
                };
            }

            const warehouseLocation = Object.values(variantData.locations || {}).find(loc => {
                return loc.isWarehouse === true;
            });

            const hasAnyNonWarehouseStoreStock = Object.values(variantData.locations || {}).some((loc) => {
                return loc.isWarehouse !== true && loc.totalAvailable > 0;
            });

            const hasAnyPickupStoreStock = Object.values(variantData.locations || {}).some((loc) => {
                return loc.isWarehouse !== true && loc.enableForPickup === true && loc.totalAvailable > 0;
            });

            const storeLocationData = variantData.locations?.[locationKey];

            if (!storeLocationData) {
                const warehouseStatus = warehouseLocation
                    ? (warehouseLocation.totalAvailable > 0 ? 'in-stock' : 'out-of-stock')
                    : 'out-of-stock';

                return {
                    storeStockStatus: 'out-of-stock',
                    warehouseStockStatus: warehouseStatus,
                    clickCollectStatus: 'unavailable',
                    warehouseQuantity: warehouseLocation?.totalAvailable ?? 0,
                    hasAnyStoreStock: variantData.totalStoreAvailable > 0,
                    hasAnyNonWarehouseStoreStock,
                    hasAnyPickupStoreStock,
                };
            }

            const warehouseStatus = warehouseLocation
                ? (warehouseLocation.totalAvailable > 0 ? 'in-stock' : 'out-of-stock')
                : 'out-of-stock';
            
            return {
                ...storeLocationData,
                warehouseStockStatus: warehouseStatus,
                warehouseQuantity: warehouseLocation?.totalAvailable ?? 0,
                hasAnyStoreStock: variantData.totalStoreAvailable > 0,
                hasAnyNonWarehouseStoreStock,
                hasAnyPickupStoreStock,
            };
        }
        
        
        async loadProductAvailability(productId) {
            if (this.productAvailabilityCache) return this.productAvailabilityCache;
            
            const response = await this.fetchProductAndLocationData(productId);
            const { product, locations } = response;
            
            if (!product || !locations) {
                this.style.display = "none";
                return {};
            }
            
            product.variants.edges.forEach(({ node: variant }) => {
                const variantId = variant.id;
                const hideStockDisplay = variant.hideStockDisplay?.value ?? null;
                const locationsMap = {};
                let totalWarehouseAvailable = 0;
                let totalStoreAvailable = 0;
                
                variant.inventoryItem.inventoryLevels.edges.forEach(({ node: level }) => {
                    const loc = level.location;
                    const locationId = loc.id;
                    const availableQuantity = level.quantities.find(q => q.name === 'available')?.quantity ?? 0;
                    
                    if (!locationsMap[locationId]) {
                        locationsMap[locationId] = {
                            name: loc.name,
                            storeHidden: loc.storeHidden?.value === 'true',
                            enableForPickup: loc.enableForPickup?.value === 'true',
                            storeEnable: loc.storeStockAvailability?.value === 'true',
                            warehouseEnable: loc.warehouseStockAvailability?.value === 'true',
                            isWarehouse: loc.isWarehouse?.value === 'true',
                            inStockThreshold: parseInt(loc.inStockThreshold?.value) ?? 0,
                            outOfStockThreshold: parseInt(loc.outOfStockThreshold?.value) ?? 0,
                            storeAvailable: 0,
                            warehouseAvailable: 0,
                            totalAvailable: 0,
                            storeStockStatus: null,
                            warehouseStockStatus: 'out-of-stock',
                            clickCollectStatus: null,
                        };
                    }
                    
                    const store = locationsMap[locationId];
                    store.totalAvailable += availableQuantity;
                    
                    if (store.storeEnable) {
                        store.storeAvailable += availableQuantity;
                        totalStoreAvailable += availableQuantity;
                    }
                    
                    if (store.warehouseEnable) {
                        store.warehouseAvailable += availableQuantity;
                        totalWarehouseAvailable += availableQuantity;
                    }

                    store.storeStockStatus = store.storeAvailable > 0 ? (store.storeAvailable <= this.thresholdLowStock ? 'low-in-stock' : 'available')
                    : 'unavailable';
                    store.warehouseStockStatus = store.warehouseAvailable > 0 ? 'available' : 'unavailable';
                    store.clickCollectStatus =
                        (this.blockClickCollect || store.totalAvailable <= 0 || store.enableForPickup !== true ) ? 'unavailable' : (store.totalAvailable <= this.thresholdLowStock ? 'low-in-stock' : 'available');
                    if (hideStockDisplay === 'true') {
                        store.storeStockStatus = 'unavailable';
                    }
                });
                
                locations.edges.forEach(({ node }) => {
                    const locationId = node.id;
                    if (!locationsMap[locationId]) {
                        locationsMap[locationId] = {
                            name: node.name,
                            storeHidden: node.storeHidden?.value === 'true',
                            enableForPickup: node.enableForPickup?.value === 'true',
                            storeEnable: node.storeStockAvailability?.value === 'true',
                            warehouseEnable: node.warehouseStockAvailability?.value === 'true',
                            isWarehouse: node.isWarehouse?.value === 'true',
                            inStockThreshold: parseInt(node.inStockThreshold?.value) ?? 0,
                            outOfStockThreshold: parseInt(node.outOfStockThreshold?.value) ?? 0,
                            storeAvailable: 0,
                            warehouseAvailable: 0,
                            totalAvailable: 0,
                            storeStockStatus: 'out-of-stock',
                            warehouseStockStatus: 'unavailable',
                            clickCollectStatus: 'unavailable'
                        };
                    }
                });
                
                this.inventoryByVariantId[variantId] = {
                    hideStockDisplay,
                    totalStoreAvailable,
                    totalWarehouseAvailable,
                    locations: locationsMap
                };
            });
            
            this.locationsList = locations.edges.map(edge => edge.node);
            this.productAvailabilityCache = this.inventoryByVariantId;
            return this.productAvailabilityCache;
        }

        syncFromExternal(storeData) {
            if (!storeData || this.currentLocationId === storeData.dataId) return;

            this.currentStoreCookie = storeData;
            this.currentLocationId = storeData.dataId;

            if (this.provinceChoices && this.provinceSelectionElement.value !== storeData.province) {
                this.provinceChoices.setChoiceByValue(storeData.province);
                
                const filteredChoices = this.availableStores.filter(choice =>
                    choice.customProperties.province === storeData.province
                );
                this.storeChoices.removeActiveItems();
                this.storeChoices.removeHighlightedItems();
                this.storeChoices.clearChoices(true, true);
                this.storeChoices.setChoices(filteredChoices, 'value', 'label', true);
            }

            if (this.storeChoices) {
                this.storeChoices.setChoiceByValue(storeData.name);
            }

            this.setCurrentStore();
            this.setStockAvailability(this.currentVariantId, storeData.dataId);
        }
        
        async createSelections(variantId) {
            const locations = this.locationsList;
            if (!locations || locations.length === 0) {
                console.warn("No locations available.");
                return;
            }
            const currentLocationId = this.currentStoreCookie?.dataId ?? '';
            const currentLocationProvince = this.currentStoreCookie?.province ?? '';
            
            // Get store availability data first
            const storeChoicesList = await Promise.all(locations.map(async location => {
                const locationId = location.id.replace('gid://shopify/Location/', '');
                const stockData = this.getVariantAvailabilityByLocationId(variantId, locationId);
                return {
                    value: location.name,
                    label: location.name,
                    selected: locationId === currentLocationId,
                    customProperties: {
                        id: locationId,
                        province: location.address.province,
                        storeHidden: stockData.storeHidden,
                        enableForPickup: stockData.enableForPickup,
                        storeEnable: stockData.storeEnable,
                        stockStatus: stockData.clickCollectStatus || 'out-of-stock',
                    },
                };
            }));
            
            // Filter out stores that are hidden or disabled
            const availableStores = storeChoicesList.filter(store => 
                store.customProperties.storeHidden !== true && 
                store.customProperties.storeEnable !== false
            );
            
            // Get unique provinces that have available stores
            const availableProvinces = [...new Set(availableStores.map(store => store.customProperties.province))];
            
            // Province selection setup - only show provinces with available stores
            const provinceSelectionElement = this.provinceSelectionElement;
            
            const provinceChoices = new Choices(provinceSelectionElement, {
                searchEnabled: false,
                searchChoices: false,
                itemSelectText: '',
                placeholder: "Select state",
                callbackOnCreateTemplates: function (template) {
                    return {
                        item: (classNames, data) => {
                            let prefix = 'State:';
                            let placeholderClass = '';
                            if (data.label === classNames.placeholderValue) {
                                prefix = '';
                                placeholderClass = 'choices__placeholder';
                            }
                            
                            return template(`
                                <div class="${classNames.classNames.item.join(' ')} ${placeholderClass} ${classNames.classNames.itemSelectable.join(' ')}" data-item data-id="${data.id}" data-value="${data.value}">
                                    ${prefix} ${data.label}
                                </div>
                            `);
                        }
                    };
                },
                choices: availableProvinces.map(province => ({
                    value: province,
                    label: province,
                    selected: province === currentLocationProvince,
                })),
            });
            
            // Store selection setup
            const storeChoicesListUnselected = storeChoicesList;
            
            const selectedProvince = provinceSelectionElement.value;
            const initialFilteredStores = selectedProvince
                ? availableStores.filter(choice => choice.customProperties.province === selectedProvince)
                : availableStores;
            
            const storeChoices = new Choices(this.storeSelectionElement, {
                searchEnabled: false,
                searchChoices: false,
                itemSelectText: '',
                callbackOnCreateTemplates: function (template) {
                    return {
                        choice: (classNames, data) => {
                            const storeHidden = data.customProperties?.storeHidden;
                            const storeEnable = data.customProperties?.storeEnable;
                            const enableForPickup = data.customProperties?.enableForPickup;
                            const stockStatus = data.customProperties?.stockStatus;
                            const normalizedStatus =
                                (stockStatus === 'in-stock' || stockStatus === 'available' || stockStatus === 'low-in-stock')
                                    ? 'available'
                                    : 'unavailable';
                            if (storeEnable === false) {
                                data.disabled = true;
                            }
                            const statusLabel = normalizedStatus === 'unavailable'
                                ? '<div class="stock-display__status out-of-stock"><div class="stock-display__dot"></div><div class="stock-display__label">Unavailable</div></div>'
                                : '<div class="stock-display__status in-stock"><div class="stock-display__dot"></div><div class="stock-display__label">Available</div></div>'
                                 ;
                            return template(`
                                <div class="${(storeHidden === true) ? 'hidden' : ''} ${classNames.classNames.item.join(' ')} ${classNames.classNames.itemChoice.join(' ')} ${data.selected ? classNames.classNames.selectedState.join(' ') : '' } ${data.disabled ? classNames.classNames.itemDisabled.join(' ') : classNames.classNames.itemSelectable.join(' ') }" data-choice data-id="${data.id}" data-value="${data.value}" ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'}>
                                    <span class="store-name">${data.label}</span> ${statusLabel}
                                </div>
                            `);
                        }
                    };
                },
                placeholder: "Select store",
                choices: initialFilteredStores
            });
            
            this.provinceChoices = provinceChoices;
            this.storeChoices = storeChoices;
            this.storeChoicesList = storeChoicesListUnselected;
            this.availableStores = availableStores;
            
            provinceSelectionElement.addEventListener('change', (event) => {
                const selectedProvince = event.target.value;
                
                // Filter and update store choices - only show available stores for the selected province
                const filteredChoices = this.availableStores.filter(choice =>
                    choice.customProperties.province === selectedProvince
                );
                
                this.storeChoices.removeActiveItems();
                this.storeChoices.removeHighlightedItems();
                this.storeChoices.clearChoices(true, true);
                this.storeChoices.setChoices(filteredChoices, 'value', 'label', true);
            });
            
            // Handle store selection - use both 'change' and 'addItem' events
            // 'addItem' fires when Choices.js adds an item (including auto-select when only 1 option)
            const handleStoreChange = (selectedStore) => {
                if (!selectedStore) return;
                
                const filteredChoices = this.storeChoicesList.filter(choice =>
                    choice.value === selectedStore
                );
                
                if (filteredChoices.length === 0) return;
                
                if (this.deliveryStatusElement) this.deliveryStatusElement.textContent = "Loading...";
                if (this.storeStatusElement) this.storeStatusElement.textContent = "Loading...";
                if (this.clickCollectElement) this.clickCollectElement.textContent = "Loading...";
                
                const selectedDataId = filteredChoices[0].customProperties.id;
                const selectedProvince = filteredChoices[0].customProperties.province;
                const selectedStoreStockAvailability = filteredChoices[0].customProperties.stockStatus;
                
                this.storeChoices.setChoiceByValue(filteredChoices[0].value);
                this.provinceChoices.setChoiceByValue(selectedProvince);
                
                const storeData = {
                    name: selectedStore,
                    dataId: selectedDataId,
                    province: selectedProvince,
                    storeStockAvailability: selectedStoreStockAvailability
                };
                
                const collapsibleElement = this.collapsibleElement;
                this.toggleHide(collapsibleElement);
                this.setCookie('currentStore', storeData, 30);
                this.currentStoreCookie = this.getCookie('currentStore');
                this.setCurrentStore();
                this.setStockAvailability(this.currentVariantId, selectedDataId);
                this.setCurrentStore();
                this.setStockAvailability(this.currentVariantId, selectedDataId);
                document.dispatchEvent(new CustomEvent('global-store-sync', {
                    detail: {
                        storeData: storeData,
                        sender: this.tagName.toLowerCase()
                    }
                }));
            };
            
            this.storeSelectionElement.addEventListener('change', (event) => {
                handleStoreChange(event.target.value);
            });
            
            // Also listen to 'addItem' for cases when province has only 1 store (auto-selected)
            this.storeSelectionElement.addEventListener('addItem', (event) => {
                // Only trigger if this is from province change (not from manual selection which already triggers 'change')
                // Check if the current store cookie is different from the newly added item
                const newStore = event.detail.value;
                const currentStore = this.currentStoreCookie?.name;
                if (newStore && newStore !== currentStore) {
                    handleStoreChange(newStore);
                }
            });
        }
        
        async setCurrentStore() {
            const resultElement = this.storeResultElement;
            if (this.currentStoreCookie) {

                const location = this.locationsList.find(loc => loc.id.replace('gid://shopify/Location/', '') === this.currentStoreCookie.dataId);
                const displayName = location?.name || this.currentStoreCookie.name;

                await this.updateAttributeCart('_pickup_store_name', displayName);
                await this.updateAttributeCart('_pickup_store_id', this.currentStoreCookie.dataId);

                this.storeNameElement.innerHTML = this.currentStoreCookie.name;
                this.currentLocationId = this.currentStoreCookie.dataId;
                this.toggleShow(resultElement);
                this.toggleShow(this.inStoreRowElement);
                this.toggleShow(this.clickCollectRowElement);
            } else {
                this.toggleHide(resultElement);
                this.toggleHide(this.inStoreRowElement);
                this.toggleHide(this.clickCollectRowElement);
                if (this.storeStatusElement) this.storeStatusElement.innerHTML = '';
                if (this.deliveryStatusElement) this.deliveryStatusElement.innerHTML = '';
                if (this.clickCollectElement) this.clickCollectElement.innerHTML = '';
                this.currentLocationId = '';
            }
        }

        async updateAttributeCart(key, value) {
            try {
                const response = await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        attributes: {
                            [key]: value || '',
                        },
                    }),
                });

                const data = await response.json();
                console.log('✅ Cart attribute updated:', data.attributes);
                return data;
            } catch (error) {
                console.error('❌ Error updating pickup store attribute:', error);
            }
        }
        
        normalizeStatus(status) {
            if (!status) return 'unavailable';

            if (status === 'in-stock' || status === 'available' || status === 'low-in-stock') {
                return 'available';
            }

            return 'unavailable';
        }

        setLabelDotColor(labelElement, status) {
            if (!labelElement) return;

            const normalizedStatus = this.normalizeStatus(status);
            if (!this.currentStoreCookie) {
                return
            }

            labelElement.classList.remove('status-available', 'status-unavailable', 'status-in-stock', 'status-out-of-stock');
            
            if (normalizedStatus === 'available') {
                labelElement.classList.add('status-available');
            } else if (normalizedStatus === 'unavailable') {
                labelElement.classList.add('status-unavailable');
            }
        }
        
        setStockStatusHtml(element, status) {
            if (!element) return;

            const normalizedStatus = this.normalizeStatus(status);

            if (normalizedStatus === 'available') {
                element.innerHTML = `<div class="stock-display__status in-stock"><div class="stock-display__dot"></div><div class="stock-display__label">Available</div></div>`;
            } else {
                element.innerHTML = `<div class="stock-display__status out-of-stock"><div class="stock-display__dot"></div><div class="stock-display__label">Unavailable</div></div>`;
            }
        }

        setLabelStock(element, status) {
            if (!element) return;

            const normalizedStatus = this.normalizeStatus(status);
            if (!this.currentStoreCookie) {
                element.innerHTML = `Select a store`;
                return
            }

            if (normalizedStatus === 'available') {
                this.eleCurrentStore?.classList.remove("show-message");
                if (status == 'low-in-stock') {
                    element.innerHTML = `Low stock`;
                } else {
                    element.innerHTML = `In stock`;
                }
                
            } else {
                element.innerHTML = `Out of stock`;
                this.eleCurrentStore?.classList.add("show-message");
            }
        }

        allGroupsSelected() {
            const variantInputs = Array.from(document.querySelectorAll('[data-single-option-selector]'));
            if (variantInputs.length < 2) return 1;

            const groups = {};
            variantInputs.forEach(input => {
                const idx = input.dataset.index || 'option1';
                if (!groups[idx]) groups[idx] = [];
                groups[idx].push(input);
            });
            return Object.keys(groups).every(key => groups[key].some(i => i.checked));
        }
        
        updateAddToCartButtonText({ warehouseQuantity, hasAnyNonWarehouseStoreStock, hasAnyPickupStoreStock, data }) {
            const productForm = document.querySelector('product-form');
            if (!productForm) return;

            const submitButton = productForm.querySelector('[data-add-to-cart]');
            if (!submitButton) return;

            const buttonText = submitButton.querySelector('span');
            if (!buttonText) return;

            const addToCartText = window.variantStrings?.addToCart || 'Add to cart';
            const soldOutText = window.variantStrings?.soldOut || 'Sold out';
            const unavailableText = window.variantStrings?.unavailable_for_pickup || 'Unavailable for pickup';

            const isWarehouseOutOfStock = warehouseQuantity <= 0;

            const showPickupInStore =
                isWarehouseOutOfStock &&
                !this.blockClickCollect &&
                hasAnyPickupStoreStock;

            const showUnavailable =
                isWarehouseOutOfStock &&
                (this.blockClickCollect || !hasAnyPickupStoreStock) &&
                hasAnyNonWarehouseStoreStock;

            const showSoldOut =
                isWarehouseOutOfStock &&
                !hasAnyNonWarehouseStoreStock;

            const pickupStoreMessageElement = productForm.querySelector('[data-pickup-store-message]');

            if (!this.allGroupsSelected()) {
                submitButton.removeAttribute('disabled');
                submitButton.setAttribute('aria-disabled', 'false');
                buttonText.textContent = window.variantStrings?.selectSize || 'Select a size';
                return;
            }

            if (pickupStoreMessageElement) {
                pickupStoreMessageElement.hidden = !showPickupInStore;
            }

            const normalizedStoreStatus = this.normalizeStatus(data.storeStockStatus);
            const normalizedClickCollectStatus = this.normalizeStatus(data.clickCollectStatus);
            document.querySelector("#ispickupstore")?.remove();
            if (showPickupInStore) {
                if (!this.currentStoreCookie) {
                    submitButton.setAttribute('disabled', 'disabled');
                    submitButton.setAttribute('aria-disabled', 'true');
                    buttonText.textContent = 'Select a store';
                } else {
                    if (normalizedStoreStatus == "unavailable" && normalizedClickCollectStatus == "unavailable") {
                        submitButton.setAttribute('disabled', 'disabled');
                        submitButton.setAttribute('aria-disabled', 'true');
                        buttonText.textContent = 'Select a store';
                    } else {
                        submitButton.removeAttribute('disabled');
                        submitButton.setAttribute('aria-disabled', 'false');
                        buttonText.textContent = 'Pickup in store';
                        productForm.querySelector("form")?.insertAdjacentHTML('beforeend', `<input type="hidden" name="properties[_is_cc]" value="Yes" id="ispickupstore">`);
                    }
                }
                const deliveryEle = document.querySelector("[data-value-delivery]");
                if (deliveryEle) {
                    deliveryEle.textContent = 'Out of stock';
                    deliveryEle.classList.add("status-unavailable");
                }
                return;
            }

            if (showUnavailable) {
                submitButton.setAttribute('disabled', 'disabled');
                submitButton.setAttribute('aria-disabled', 'true');
                buttonText.textContent = unavailableText;
                return;
            }

            if (showSoldOut) {
                submitButton.setAttribute('disabled', 'disabled');
                submitButton.setAttribute('aria-disabled', 'true');
                buttonText.textContent = soldOutText;
                return;
            }

            const deliveryEle = document.querySelector("[data-value-delivery]");
            const statusDelivery = deliveryEle.getAttribute("data-value-delivery");
            if (deliveryEle) {
                deliveryEle.textContent = statusDelivery;
                deliveryEle.classList.remove("status-unavailable");
            }
            submitButton.removeAttribute('disabled');
            submitButton.setAttribute('aria-disabled', 'false');
            buttonText.textContent = addToCartText;
        }

        hidePickupStoreMessage() {
            const productForm = document.querySelector('product-form');
            const pickupStoreMessageElement = productForm?.querySelector('[data-pickup-store-message]');
            if (pickupStoreMessageElement) {
                pickupStoreMessageElement.hidden = true;
            }
        }

        async setStockAvailability(variantId, locationId) {
            const hasSelectedStore = Boolean(locationId && this.currentStoreCookie);
            const data = this.getVariantAvailabilityByLocationId(variantId, locationId);
            const block_list = document.querySelector(".block_product-grouped-list");
            if (block_list) {
                block_list.classList.remove("disabled");
            }
            if (!this.allGroupsSelected()) {
                const productForm = document.querySelector('product-form');
                if (!productForm) return;

                const submitButton = productForm.querySelector('[data-add-to-cart]');
                if (!submitButton) return;

                const buttonText = submitButton.querySelector('span');
                if (!buttonText) return;
                if (!this.allGroupsSelected()) {
                    submitButton.removeAttribute('disabled');
                    submitButton.setAttribute('aria-disabled', 'false');
                    buttonText.textContent = window.variantStrings?.selectSize || 'Select a size';
                }
                block_list.classList.add("disabled");
                return;
            }
            if (data !== null) {
                const warehouseStatus = data.warehouseStockStatus || 'out-of-stock';

                console.log('[CHECK STORE STATUS]', {
                    locationId,
                    storeStockStatus: data.storeStockStatus,
                    warehouseStockStatus: data.warehouseStockStatus,
                    warehouseStatus: warehouseStatus,
                    clickCollectStatus: data.clickCollectStatus,
                });


                const normalizedStoreStatus = this.normalizeStatus(data.storeStockStatus);
                const normalizedDeliveryStatus = this.normalizeStatus(data.warehouseStockStatus);
                const normalizedClickCollectStatus = this.normalizeStatus(data.clickCollectStatus);

                this.setStockStatusHtml(this.storeStatusElement, normalizedStoreStatus);
                this.setStockStatusHtml(this.deliveryStatusElement, normalizedDeliveryStatus);
                this.setStockStatusHtml(this.clickCollectElement, normalizedClickCollectStatus);

                this.setLabelDotColor(this.storeLabelElement, normalizedStoreStatus);
                this.setLabelDotColor(this.clickCollectLabelElement, normalizedClickCollectStatus);
                this.setLabelDotColor(this.storeLabelElementTab, normalizedStoreStatus);
                this.setLabelDotColor(this.clickCollectLabelElementTab, normalizedClickCollectStatus);
                const updatedStoreChoicesList = await this.checkStockStores(variantId);
                const hasStockStore = updatedStoreChoicesList?.some(item => {
                    const stockStatus = item.customProperties?.stockStatus;
                    return stockStatus === 'in-stock' || stockStatus === 'available' || stockStatus === 'low-in-stock';
                });
                const hasStockClick = updatedStoreChoicesList?.some(item => {
                    const stockStatus = item.customProperties?.clickCollectStatus;
                    return stockStatus === 'in-stock' || stockStatus === 'available' || stockStatus === 'low-in-stock';
                });
                let number_block_soldout = 0;
                if (hasStockStore) {
                    if (data.storeStockStatus == 'in-stock' || data.storeStockStatus === 'available' || data.storeStockStatus === 'low-in-stock') {
                        if (data.storeStockStatus == 'low-in-stock') {
                            this.setLabelStock(this.storeLabelElementTab, data.storeStockStatus);
                        } else {
                            this.setLabelStock(this.storeLabelElementTab, normalizedStoreStatus);              
                        }
                    } else {
                        if (this.storeLabelElementTab) {
                            this.storeLabelElementTab.innerHTML = 'Check other stores';
                            this.storeLabelElementTab.classList.remove("status-unavailable");
                        }
                        this.eleCurrentStore?.classList.add("show-message");
                    }
                } else {
                    number_block_soldout = 1;
                    if (this.storeLabelElementTab) {
                        this.storeLabelElementTab.innerHTML = 'Out of stock';
                        this.storeLabelElementTab.classList.add("status-unavailable");
                    }
                }
                if (hasStockClick) {
                    if (data.clickCollectStatus == 'in-stock' || data.clickCollectStatus === 'available' || data.clickCollectStatus === 'low-in-stock') {
                        if (data.clickCollectStatus == 'low-in-stock') {
                            this.setLabelStock(this.clickCollectLabelElementTab, data.clickCollectStatus);
                        } else {
                            this.setLabelStock(this.clickCollectLabelElementTab, normalizedClickCollectStatus);              
                        }
                    } else {
                        if (this.clickCollectLabelElementTab) {
                            this.clickCollectLabelElementTab.innerHTML = 'Check other stores';
                            this.clickCollectLabelElementTab.classList.remove("status-unavailable");
                        }
                    }
                } else {
                    number_block_soldout = 2;
                    if (this.clickCollectLabelElementTab) {
                        this.clickCollectLabelElementTab.innerHTML = 'Out of stock';
                        this.clickCollectLabelElementTab.classList.add("status-unavailable");
                    }
                }

                if (number_block_soldout == 2 && document.querySelector("[data-value-delivery]").classList.includes("status-unavailable")) {
                    const block_list = document.querySelector(".block_product-grouped-list");
                    if (block_list) {
                        block_list.classList.add("disabled");
                    }
                }

                this.updateAddToCartButtonText({
                    warehouseQuantity: data.warehouseQuantity ?? 0,
                    hasAnyNonWarehouseStoreStock: data.hasAnyNonWarehouseStoreStock === true,
                    hasAnyPickupStoreStock: data.hasAnyPickupStoreStock === true,
                    data: data
                });

                if (!hasSelectedStore) {
                    this.storeMessageElement.innerHTML = '';
                    return;
                }
                
                if (normalizedStoreStatus === 'unavailable') {
                    const selectedLocation = this.locationsList?.find(
                        (loc) => loc.id.replace('gid://shopify/Location/', '') === locationId
                    );
                    const displayName = selectedLocation?.name || this.storeNameElement.textContent;

                    this.storeMessageElement.innerHTML = `Sorry, this product is unavailable at ${displayName}.`;
                } else {
                    this.storeMessageElement.innerHTML = '';
                }
            } else {
                this.hidePickupStoreMessage();
            }
        }
        
        collapsibleEvent() {
            const collapsibleElement = this.collapsibleElement;
            this.collapsibleTriggerElements.forEach(trigger =>
                trigger.addEventListener('click', () => this.toggleShowHide(collapsibleElement))
            );
        }
        
        toggleShowHide(element) {
            if (!element) return;
            element.classList.toggle('hide');
            this.reCalculateAccordionHeight();
            if (element.classList.contains("hide") == false && window.innerWidth < 750) {
                const targetElement = document.querySelector('.block_product-grouped__collage');
                if (targetElement) {
                    const totalTop = targetElement.getBoundingClientRect().top + window.scrollY;
                    const offsetPosition = totalTop - 160;
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }
        }
        
        toggleHide(element) {
            if (!element) return;
            element.classList.add('hide');
        }
        
        toggleShow(element) {
            if (!element) return;
            element.classList.remove('hide');
        }
        
        reCalculateAccordionHeight() {
            const accordionContent = this.closest('.accordion-content');
            if (accordionContent) {
                accordionContent.style.maxHeight = `${accordionContent.scrollHeight + 15}px`;
            }
        }
        
        setCookie(name, value, days = 7) {
            const expires = new Date();
            expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
            const cookieValue = JSON.stringify(value);
            document.cookie = `${name}=${encodeURIComponent(cookieValue)};expires=${expires.toUTCString()};path=/`;
        }
        
        getCookie(name) {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) {
                    try {
                        return JSON.parse(decodeURIComponent(c.substring(nameEQ.length, c.length)));
                    } catch (e) {
                        console.error("Error parsing cookie value:", e);
                        return null;
                    }
                }
            }
            return null;
        }
        
        onVariantChange() {
            // Subscribe to variant change events using the pub/sub system
            this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, async (event) => {
                const variant = event.data?.variant?.id;
                
                if (variant) {
                    this.dataset.variantId = variant;
                    this.currentVariantId = variant;

                    this.setStockAvailability(variant, this.currentLocationId);
                    await this.updateStoreChoicesForVariant(variant);
                }
            });
        }
        
        disconnectedCallback() {
            // Clean up the variant change subscription
            if (this.variantChangeUnsubscriber) {
                this.variantChangeUnsubscriber();
            }
        }

        async checkStockStores(variantId) {
            if (!this.storeChoices && !this.locationsList) {
                console.warn('Store choices or locations list not available');
                return;
            }
            
            const locations = this.locationsList;
            const currentLocationId = this.currentStoreCookie?.dataId ?? ''; 
            const updatedStoreChoicesList = await Promise.all(locations.map(async location => {
                const locationId = location.id.replace('gid://shopify/Location/', '');
                const stockData = this.getVariantAvailabilityByLocationId(variantId, locationId);
                return {
                    value: location.name,
                    label: location.name,
                    selected: locationId === currentLocationId,
                    customProperties: {
                        id: locationId,
                        province: location.address.province,
                        storeHidden: stockData.storeHidden,
                        enableForPickup: stockData.enableForPickup,
                        storeEnable: stockData.storeEnable,
                        clickCollectStatus: stockData.clickCollectStatus || 'out-of-stock',
                        stockStatus: stockData.storeStockStatus || 'out-of-stock',
                    },
                };
            }));
            return updatedStoreChoicesList;
        }
        
        async updateStoreChoicesForVariant(variantId) {
            this.productAvailabilityCache = null;
            
            if (!this.storeChoices || !this.locationsList) {
                console.warn('Store choices or locations list not available');
                return;
            }

            const freshCache = await this.loadProductAvailability(this.currentProductId);
            this.productAvailabilityCache = freshCache;
            
            const locations = this.locationsList;
            const currentLocationId = this.currentStoreCookie?.dataId ?? ''; 
            const updatedStoreChoicesList = locations.map(location => {
                const locationId = location.id.replace('gid://shopify/Location/', '');
                const stockData = this.getVariantAvailabilityByLocationId(variantId, locationId);
                
                //console.log(`Store ${location.name} (${locationId}) stock status:`, stockData.storeStockStatus);
                
                return {
                    value: location.name,
                    label: location.name,
                    selected: locationId === currentLocationId,
                    customProperties: {
                        id: locationId,
                        province: location.address.province,
                        storeHidden: stockData.storeHidden,
                        enableForPickup: stockData.enableForPickup,
                        storeEnable: stockData.storeEnable,
                        clickCollectStatus: stockData.clickCollectStatus || 'out-of-stock',
                        stockStatus: stockData.storeStockStatus || 'out-of-stock',
                    },
                };
            });
            
            // Filter out stores that are hidden or disabled
            const updatedAvailableStores = updatedStoreChoicesList.filter(store => 
                store.customProperties.storeHidden !== true && 
                store.customProperties.storeEnable !== false
            );
            // Update the stored lists
            this.storeChoicesList = updatedStoreChoicesList;
            this.availableStores = updatedAvailableStores;
            
            // Update province choices if needed
            const updatedAvailableProvinces = [...new Set(updatedAvailableStores.map(store => store.customProperties.province))];
            if (this.provinceChoices) {
                this.provinceChoices.clearChoices(true, true);
                this.provinceChoices.setChoices(updatedAvailableProvinces.map(province => ({
                    value: province,
                    label: province,
                    selected: province === this.currentStoreCookie?.province,
                })), 'value', 'label', true);
            }
            
            // Update store choices for the currently selected province
            const selectedProvince = this.provinceSelectionElement?.value || this.currentStoreCookie?.province;
            const filteredChoices = selectedProvince
                ? updatedAvailableStores.filter(choice => choice.customProperties.province === selectedProvince)
                : updatedAvailableStores;

            if (this.storeChoices) {
                this.storeChoices.removeActiveItems();
                this.storeChoices.removeHighlightedItems();
                this.storeChoices.clearChoices(true, true);
                this.storeChoices.setChoices(filteredChoices, 'value', 'label', true);
            }
        }
    }
    
    customElements.define('stock-display-cc', StockDisplayCC);
}